import React, { useState, Component, forwardRef, useRef, useImperativeHandle } from 'react';
import { useContext } from "react";
import AuthContext from "../../AuthContext";
import { Navigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faCircle, faCheckCircle, faPlus } from '@fortawesome/free-solid-svg-icons';
import { getShoppingLists, createShoppingList, updateShoppingListItem, deleteShoppingList } from '../../api/backend';
import ShoppingItems from "./ShoppingItems";
import BasicModal from "./BasicModal";
import { Application } from '../../core/app';

class ShoppingImp extends Component {
    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.hasRequestedLists = false;
    }       
    
    state = {
        lists: [],
        inputValue: '',
        totalItemCount: 0,
        totalItemAmount: 0,
        selectedListId: null,
      }

    componentDidMount() {
        this.loadListsIfReady();
    }

    componentWillUnmount() {
    }

    loadListsIfReady = () => {
        if (!Application.getAccessToken() || this.hasRequestedLists) {
            return;
        }

        this.hasRequestedLists = true;
        getShoppingLists().then(res => {
            const lists = res.data;
            this.setState({ lists });

            // First check localStorage for user's selection
            const savedSelectedListId = Application.getSelectedShoppingList();
            if (savedSelectedListId) {
                const selectedList = lists.find(list => list.id === savedSelectedListId);
                if (selectedList) {
                    this.setState({ selectedListId: selectedList.id });
                    this.child.current.getItems(selectedList.id);
                }
            } else {
                // Fallback to backend selection if no localStorage
                const selectedListFromBackend = lists.find(list => list.selected);
                if (selectedListFromBackend) {
                    this.setState({ selectedListId: selectedListFromBackend.id });
                    this.child.current.getItems(selectedListFromBackend.id);
                }
            }
        }).catch(() => {
            // Avoid a retry loop when the initial request fails.
        });
    }

    getItemList = (id) => {
        this.setState({ selectedListId: id });
        this.child.current.getItems(id);
        
    }


    getLists = () => {
        return getShoppingLists().then(res => {
            const lists = res.data;
            this.setState({ lists });
        });
    }

    setItems = (newItems) => {
        this.setState({ newItems });
    }

    setInputValue = (value) => {
        this.setState({ inputValue: value });
    }

    setItemTotals = (total_quantity, total_amount) => {
        this.setState({
            totalItemCount: total_quantity, 
            totalItemAmount: total_amount,
        });
    }

	// HINT: each "item" in our list names a name,
	// a boolean to tell if its been completed, and a quantity
	

	handleAddButtonClick = () => {
		const newItem = {
			name: this.state.inputValue
		};

        createShoppingList(newItem).then(res => {
            this.getLists();
        });

		const newItems = [...this.state.lists, newItem];

		this.setItems(newItems);
		this.setInputValue('');
	};

    updateItem = (item) => {
        updateShoppingListItem(item).then(res => {
            this.getLists();
        });
    }

	handleQuantityIncrease = (index) => {
		const newItems = [...this.state.items];
		newItems[index].quantity++;

        this.updateItem(newItems[index]);

		this.setItems(newItems);
	};

	handleQuantityDecrease = (index) => {
		const newItems = [...this.state.items];

		newItems[index].quantity--;

        this.updateItem(newItems[index]);

		this.setItems(newItems);
	};

	toggleComplete = (index) => {
		const newItems = [...this.state.items];

		newItems[index].isSelected = !newItems[index].isSelected;

        this.updateItem(newItems[index]);

		this.setItems(newItems);
	};

    handleListDelete = (list) => {
        deleteShoppingList(list.id).then(res => {
            this.getLists();
        });
    };
    

    render() {
        const selectedList = this.state.lists.find(list => 
            list.id === this.state.selectedListId
        );
        
        return (
            <div className='app-background'>
                <div className='main-shopping-container shopping-page'>
                    {/* <div className='add-item-box'>
                        <input value={this.state.inputValue} onChange={(event) => this.setInputValue(event.target.value)} className='add-item-input' placeholder='Add an item...' />
                        <FontAwesomeIcon icon={faPlus} onClick={() => this.handleAddButtonClick()} />
                    </div> */}
                    <div className='shopping-header'>
                        <BasicModal
                            selected={this.state.lists}
                            lists={this.state.lists}
                            getItemList={this.getItemList}
                            handleAddButtonClick={this.handleAddButtonClick}
                            setInputValue={this.setInputValue}
                            inputValue={this.state.inputValue}
                            handleListDelete={this.handleListDelete}
                        />
                        <div className='shopping-summary'>
                            <div className='selected-list-title'>
                                {selectedList ? `${selectedList.name}` : 'No list selected'}
                            </div>
                            <div className='total shopping-total'>Total Items: {this.state.totalItemCount}</div>
                        </div>
                    </div>
                    <ShoppingItems
                        ref={this.child}
                        selected={this.state.lists}
                        selectedListId={this.state.selectedListId}
                        setItemTotals={this.setItemTotals}
                    />
                </div>
                
            </div>
        );
    };
};

export default function Shopping() {
    const { user } = useContext(AuthContext);
    if (!user) {
        return <Navigate replace to="/login" />;
    } else {
        return <ShoppingImp/>
    }
}